import React, { useContext, useEffect, useState } from "react";
import SellerSidebar from "../../../navigation/sellerNavigation";
import FormInput from "../../../props/propertyFormProp";
import { UserContext } from "../../../context/userContext";
import { patchData } from "../../../fetchRoutes/patchData";
import {patchDataFile} from "../../../fetchRoutes/patchDataWithFile";
import { emailValidation} from "../../../utility/validation";
import SellerMobileSidebar from "../../../navigation/sellerMobileNavigation";
import { DeviceContext } from "../../../context/deviceContext";


export default function UpdateDetailContainer() {

    const notificationsUrl = process.env.REACT_APP_NOTIFICATIONS;
    const updateMeUrl =  process.env.REACT_APP_UPDATE_ME;


    const {userDetails, setUserDetails} = useContext(UserContext);
    const {isMobile}= useContext(DeviceContext);
    

    const [newUser, setNewUser] = useState({
        name: "",
        email: "",
        username: "",
        image: ""
    });    

    const [previewImage, setPreviewImage] = useState(null);
    const [notificationsEnabled, setNotificationsEnabled] = useState(userDetails.notification); 
    const [errors, setErrors] = useState("");
    const [success, setSuccess] = useState(false);
    const [errorMessage, setErrorMessage]= useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isDataAvailable, setIsDataAvailable] = useState(true);



    const handleChange = (event) => {
        const { name, value } = event.target;
        setNewUser((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            
            setNewUser((prevState) => ({
                ...prevState,
                image: file
            }));
            setPreviewImage(URL.createObjectURL(file));
    
        }
    };

    useEffect(() => {
        setNotificationsEnabled(userDetails.notification);
    }, [userDetails.notification]);

    useEffect(()=>{
       if (userDetails.image){
        setIsDataAvailable(true);
       }
    },[userDetails]);
    
      
    
    
    // Handles the notifacation toggle
    const handleToggleChange = () => {
        setNotificationsEnabled(!notificationsEnabled); 

        async function updateNotification() {
            setIsLoading(true);
            try{
                const response = await patchData(notificationsUrl);

                if(response.status === 'Success'){
                    setIsLoading(false);
                    setUserDetails((prevState) => ({
                        ...prevState,
                        notification: !notificationsEnabled
                    }));
                }
            }catch(err){
                setErrors("Something went wrong!"); 
                setTimeout(() => {
                    setErrors("");
                }, 3000);
            }finally{
                setIsLoading(false);
                setErrors("");
            }
        }
        updateNotification();
    };

    // Handles the form submission
    const handleFormSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        setErrors("");

        // Validate email format
        if (newUser.email && !emailValidation(newUser.email)) {
            setErrors("Invalid email!");
            setIsLoading(false);
            return;
        }

        try {
            const formData = new FormData();

            // Fields to append to the FormData
            const fieldsToAppend = {
                name: newUser.name,
                email: newUser.email,
                username: newUser.username,
            };

            // Check if the image exists and is a File
            if (newUser.image && newUser.image instanceof File) {
                // Append the image directly to FormData
                formData.append('image', newUser.image);
                console.log('Image appended to FormData:', newUser.image);
            }

            // Loop through fields and append non-empty fields
            Object.entries(fieldsToAppend).forEach(([key, value]) => {
                if (value) {
                    formData.append(key, value);
                }
            });

            const response = await patchDataFile(updateMeUrl, formData);

            if (response.status === 'Success') {
                setUserDetails({
                    ...userDetails,
                    name: response.data.name,
                    email: response.data.email,
                    username: response.data.username,
                    image: response.data.image
                });

                setSuccess(true);
                setTimeout(() => {
                    setSuccess(false);
                }, 3000);
            }

        } catch (err) {
            setErrorMessage("Something went wrong!");
        } finally {
            setIsLoading(false);
            setNewUser({
                name: "",
                email: "",
                username: "",
                image: ""
            });
        }
    };



    return (
        <div className="sellerDashboard ">
            {isMobile ? <SellerMobileSidebar/> :<SellerSidebar />}
            <div className="container updateContainer">
                {/* Background Objects */}
                <section>
                    <div className="circle bgOrange" />
                    <div className="circle bgPink" />
                    <h1 className="containerTitle">UPDATE MY DETAILS</h1>
                </section>

                {isLoading && (
                    <div className="loaderContainer">
                        <div className="loader"></div>
                        <p className="loadingText"> Updating your details...</p>
                    </div>
                )}

                {success && (
                    <div className="successMessageUpdate">
                        <span className="checkmark">✔</span> Details updated successfully!
                    </div>
                )}

                {isDataAvailable ? (
                    <section className="userSection">
                        {/* This is for the user information */}
                        
                        <div className="card userDetailCard">
                            <div className="userInfoContainer">
                                {/* User Image */}
                                <div className="userImageContainer">
                                    <img
                                        alt="Profile"
                                        className="avatar"
                                        style={{
                                            backgroundImage: `url(${process.env.REACT_APP_BACKEND}/${userDetails.image?.replace('public/', '')})`
                                        }}
                                    />
                                </div>

                                {/* User Info */}
                                <div className="userDetails">
                                    <p className="userUsername">@{userDetails.username}</p>
                                    <div className="detail">
                                        <p className="pTitle">Name:</p>
                                        <p className="userName">{userDetails.name}</p>

                                    </div>

                                    <div className="detail">
                                        <p className="pTitle">Email:</p>
                                        <p className="userName">{userDetails.email}</p>
                                    </div>
                                </div>  
                            </div>                        

                            <div className="notificationToggle">
                                <label className="toggleLabel">
                                    Notifications
                                </label>
                                <div 
                                    className={`toggleSwitch ${notificationsEnabled ? 'on' : 'off'}`}
                                    onClick={handleToggleChange}
                                    role="switch"  
                                    aria-checked={notificationsEnabled} 
                                    aria-label="Notifications Toggle"
                                >
                                    <div className={`toggleCircle ${notificationsEnabled ? 'on' : 'off'}`}>
                                        
                                    </div>
                                    
                                </div>

                                <div className="onOff">
                                    <p className="onOffText">{notificationsEnabled ? 'On' : 'Off'}</p>
                                </div>
                            </div>


                        </div>

                        {/* This is for the form */}
                        <div className="card updateMeCard">
                            <form className="addPropertyForm updateMeForm" onSubmit={handleFormSubmit}> 
                                <div className="updateFormContainer">

                                    <div className="leftSide">
                                        <FormInput 
                                            label="Name" 
                                            name="name" 
                                            type="text" 
                                            placeholder="Enter your name" 
                                            required={false}
                                            value={newUser.name} 
                                            astriskClass="hideMe"
                                            onChange={handleChange} 
                                            minLength={3}
                                        
                                        />


                                        <FormInput 
                                            label="Email" 
                                            name="email" 
                                            type="email" 
                                            placeholder="Enter your new email" 
                                            required={false}
                                            value={newUser.email} 
                                            astriskClass="hideMe"
                                            onChange={handleChange} 
                                            minLength={3}
                                            className={errors ? "error" : ""}
                                            errorMessage={errors}
                                        
                                        />


                                        <FormInput 
                                            label="Username" 
                                            name="username" 
                                            type="text" 
                                            placeholder="Enter your new username" 
                                            required={false}
                                            value={newUser.username} 
                                            onChange={handleChange} 
                                            astriskClass="hideMe"
                                            minLength={3}
                                        />

                                    </div>

                                    {/* Profile Picture Update Section */}

                                    <div className="card imageUploadCard">
                                        <div className="imagePreview">
                                            <img
                                                src={
                                                previewImage ||
                                                "https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png"
                                                }
                                                alt="Preview"
                                            />
                                        </div>

                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={handleImageChange}
                                            className="fileInput"
                                        />
                                    </div>

                                </div>
                                
                        
                                <div className="formButton">
                                    <button type="submit" className="submitButton">Update</button>
                                    {errorMessage && ( <p className="errorMessage">{errorMessage}</p>)}
                                </div>

                            </form>
                            
                        </div>

                 
                    </section>

                ):(
                    <div className="loaderContainer">
                        <div className="loader"></div>
                        <p className="loadingText"> Loading...</p>
                    </div>
                )}
                
                

            </div>
           
        
        </div>
    );
}





